module.exports = __webpack_public_path__ + "static/media/step-2.e548c4c0.png";